
























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";

import {
  faDiscord,
  faTwitter,
  faTelegram,
  faGithub,
  faFacebook,
  faMediumM,
} from "@fortawesome/free-brands-svg-icons";

library.add(faDiscord, faTwitter, faTelegram, faGithub, faFacebook, faMediumM);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class Footer extends Vue {
  @Prop(Boolean) private showLogo!: boolean;

  private appVersion = `v${process.env.GIT_VERSION}`;

  private langs = {
    ar: "arabic",
    en: "english",
    id: "indonesian",
    ja: "japanese",
    ko: "korean",
    pt: "portuguese",
    ru: "russian",
    es: "spanish",
    vi: "vietnamese",
  };

  private setDocumentLang() {
    const el = document.getElementsByTagName("html")[0];
    el.setAttribute("lang", this.$i18n.locale);
  }
}
